<div class="action action-submitting">
  <div class="action-submitting__spinner-container">
    <app-spinner></app-spinner>
  </div>

  <div class="action-submitting__tagline">
    <p tabindex="-1" #tagline>{{ actionText }}...</p>
  </div>
</div>
